(function() {
  'use strict';

  if (customElements.get('lepro-category-slider')) return;

  customElements.define('lepro-category-slider', class extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.category-grid');
      if (!track) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const nav = this.querySelector('.category-slider-nav');
      const prev = this.querySelector('[data-category-prev]');
      const next = this.querySelector('[data-category-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let drag = null;
      let suppressClick = false;

      const update = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        nav.hidden = maxScroll <= 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= maxScroll - 1;
        track.classList.toggle('is-draggable', maxScroll > 1);
      };

      const move = (direction) => {
        const item = track.querySelector('.category-item');
        if (!item) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({
          left: direction * (item.getBoundingClientRect().width + gap),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      };

      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.target !== track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, options);

      // Leave touch scrolling native; add dragging for desktop mice.
      track.addEventListener('pointerdown', (event) => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || nav.hidden) return;
        drag = { id: event.pointerId, x: event.clientX, scroll: track.scrollLeft, moved: false };
      }, options);

      track.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        const distance = event.clientX - drag.x;
        if (!drag.moved && Math.abs(distance) < 6) return;
        if (!drag.moved) {
          drag.moved = true;
          track.setPointerCapture(drag.id);
          track.classList.add('is-dragging');
        }
        event.preventDefault();
        track.scrollLeft = drag.scroll - distance;
      }, options);

      const endDrag = (event) => {
        if (!drag || event.pointerId !== drag.id) return;
        suppressClick = drag.moved;
        if (track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id);
        drag = null;
        track.classList.remove('is-dragging');
      };

      track.addEventListener('pointerup', endDrag, options);
      track.addEventListener('pointercancel', endDrag, options);
      track.addEventListener('lostpointercapture', endDrag, options);
      track.addEventListener('pointerleave', (event) => {
        if (drag && !drag.moved) endDrag(event);
      }, options);
      track.addEventListener('dragstart', (event) => event.preventDefault(), options);
      track.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, { ...options, capture: true });

      this.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('.category-item');
        if (item) track.scrollTo({ left: track.scrollLeft + item.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'auto' });
      }, options);

      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  });
})();
